<!--
通用普通页面模板
-->
<style lang="less" scoped>
    @import "~@/public/less/index.less";
    .z-plugin-listno{
        width: 100%; height: 100% !important; overflow: hidden;
        .head{
            margin: 0 20px 20px 20px; font-size: 1.1em; font-weight: bold;
        }
        .subHead{
            margin: 0 20px 20px 20px;
        }
    }
</style>
<template>
    <div class="zee zee-component z-plugin-listno">
        <z-layout ref="zlayout"
                  v-if="superApi && superColumns"
                  :superPage="page"
                  :superApi="superApi"
                  @reloadData="loadData">
            <!-- 面包屑 -->
            <template #breadcrumb><div></div></template>
            <!-- 头部 -->
            <template #head v-if="superTitle || $slots.subHead">
                <div class="head" v-if="superTitle">{{superTitle}}</div>
                <div class="subHead" v-if="$slots.subHead"><slot name="subHead"></slot></div>
            </template>
            <!-- 检索 -->
            <template #subHeadLeft v-if="$slots.subHeadLeft">
                <slot name="subHeadLeft"></slot>
            </template>
            <template #subHeadLeft v-else>
                <z-search :superFilter="page.filter"
                          :superColumns="superColumns"
                          @change="bindSearchChange"
                          @reloadData="reloadData()">
                </z-search>
            </template>
            <!-- 按钮组 -->
            <template #subHeadRight v-if="$slots.subHeadRight">
                <slot name="subHeadRight"></slot>
            </template>
            <template #subHeadRight v-else>
                <a-button-group>
                    <a-button @click="loadData()"><template #icon><icon-refresh /></template>刷新</a-button>
                    <a-button type="primary" @click="$refs.zlayout.bindOpenCurd('新增')" ><template #icon><icon-plus /></template>新增</a-button>
                </a-button-group>
            </template>
            <!-- 子菜单 -->
            <template #menus v-if="menus && !router.navInfo.hasTmp">
                <a-menu mode="inline"
                        :style="{ height: '100%', borderRight: 0 }"
                        :defaultOpenKeys="[`/${router.info.path[0]}/${router.info.path[1]}`]"
                        :defaultSelectedKeys="[`${router.info.url}`]">
                    <template v-for="(item, index) in menus">
                        <a-sub-menu :key="index"
                                    v-if="item.info.show &&
                              item.info.type==='nav' &&
                              item.info.level===(router.navInfo.level+1) &&
                              !item.info.hasTmp && item.info.hasChild">
              <template #title>
                <component :is="'icon-' + item.info.icon" />
                <span>{{item.info.name}}</span>
              </template>
                            <template v-for="(item2, index2) in menus">
                                <a-menu-item :key="index2"
                                             v-if="item2.info.type==='nav' &&
                                   item2.info.level===(router.navInfo.level+2)"
                                             @click="$fan.page.open(index2)">
                    <span>
                      <component :is="'icon-' + item2.info.icon" />
                      <span>{{item2.info.name}}</span>
                    </span>
                                </a-menu-item>
                            </template>
                        </a-sub-menu>
                        <a-menu-item :key="'menu-' + index"
                                     v-else-if="item.info.show &&
                                    item.info.level===(router.navInfo.level+1) &&
                                    item.info.hasTmp"
                                     @click="$fan.page.open(index)">
                  <span>
                    <component :is="'icon-' + item.info.icon" />
                    <span>{{item.info.name}}</span>
                  </span>
                        </a-menu-item>
                    </template>
                </a-menu>
            </template>
            <!-- 列表 -->
            <template #body>
                <z-table v-if="data.data"
                         :superData="data"
                         :superColumns="superColumns"
                         :superFilter="page.filter"
                         @change="bindTableChange">
                    <template #actions="record">
                        <slot name="actions" :record="record.record"></slot>
                        <slot name="customActions" :record="record.record"></slot>
                        <template v-if="!$slots.customActions">
                            <slot name="actions" :record="record.record"></slot>
                            <a-tooltip content="查看" position="bottom">
                                <a-button @click="$refs.zlayout.bindOpenCurd('详情', record)"><template #icon><icon-eye /></template></a-button>
                            </a-tooltip>
    <!--                        <a-tooltip content="编辑" position="bottom">-->
    <!--                            <a-button @click="$refs.zlayout.bindOpenCurd('编辑', record)"><template #icon><icon-edit /></template></a-button>-->
    <!--                        </a-tooltip>-->
                            <!--<a-popconfirm content="删除不可恢复，是否继续？" position="br" @ok="bindDeleteRecord(record)">-->
                            <!--<a-tooltip position="bottom" title="删除" >-->
                            //<a-button status="danger"><template #icon><icon-delete /></template></a-button>
                            <!--</a-tooltip>-->
                            <!--</a-popconfirm>-->
                        </template>
                    </template>
                </z-table>
            </template>
            <!--<template #minor><p v-for="i in 50" :key="i">列表{{i}}</p></template>-->
        </z-layout>
    </div>
</template>

<script>
    export default {
        name: 'ZPluginListno',
        props: {
            superTitle: String,
            superApi: String,
            superColumns: Array
        },
        created() {
            this.page = this.$fan.utils.parse(this.def.page)
            this.data = this.$fan.utils.parse(this.def.data)
        },
        mounted() {
            if (this.superApi && this.superColumns) {
                this.reloadData()
            }
        },
        computed: {
            routers() {
                return this.$store.state.routers || {}
            },
            router() {
                return this.routers[this.$route.path] || {}
            },
            query() {
                const query = this.$route.query
                if (this.$fan.utils.notEmpty(query)) {
                    return query
                } else {
                    return false
                }
            },
            menus() {
                let menus = {}
                if (this.router && this.router.navInfo && this.router.navInfo.hasChild) {
                    for (let k in this.routers) {
                        const router = this.routers[k]
                        let routerNavUrl = ""
                        for (let i =0; i < this.router.navInfo.level; i++) {
                            routerNavUrl = routerNavUrl+"/"+router.info.path[i]
                        }
                        if (router.info.type!=='nav' && routerNavUrl===this.router.navInfo.url) {
                            menus[router.info.url] = router
                        }
                    }
                }
                return Object.keys(menus).length>0 ? menus : false
            }
        },
        data() {
            return {
                data: {}, page: {},
                def: {
                    data: {},
                    page: {
                        // 加载状态
                        initing: false,
                        loading: false,
                        // 检索参数
                        filter: {
                            page: 1,
                            limit: 10
                        }
                    }
                }
            }
        },
        methods: {
            // 网络请求
            async loadData() {
                this.page.loading = true
                const {data} = await this.$fan.api.get(this.superApi, this.page.filter)
                this.data = data
                this.$store.state.page.data = data
                this.page.loading = false
            },
            // 重置并重载
            async reloadData() {
                this.page.initing = true
                // 重置参数
                this.page.filter = this.$fan.utils.parse(this.def.page.filter)
                // 请求数据
                await this.loadData()
                // 进行载入回调
                await this.$fan.page.loadCallback(this.superColumns, this.data)
                this.page.initing = false
            },
            // 检索变化
            async bindSearchChange(filter={}) {
                this.page.loading = true
                // 写入参数
                this.page.filter = {...filter, ...this.def.page.filter}
                // 请求数据
                await this.loadData()
                // 进行载入回调
                await this.$fan.page.loadCallback(this.superColumns, this.data)
                this.page.loading = false
            },
            // 列表变化
            bindTableChange(pagination, filters, sorter) {
                this.page.filter.page = pagination.current
                this.page.filter.limit = pagination.pageSize
                this.loadData()
            },
            // 增删改查
            async bindDeleteRecord({record}) {
                let api = this.superApi.split('?')[0]
                await this.$fan.api.delete(`${api}/${record.id}`)
                this.loadData()
            },
            bindOpenCurd(title, record) {
                this.$refs.zlayout.bindOpenCurd(title, record)
            },
            // 导出
            async exportexcel() {
                let xlsColumns = []
                const columns = this.superColumns
                const data = JSON.parse(JSON.stringify(this.data.data))
                for (let k in columns) {
                if ([
                    'Id', 'ID', '操作'
                ].indexOf(columns[k].title) < 0) {
                    xlsColumns.push({
                    label: columns[k].title,
                    prop: columns[k].dataIndex
                    })
                    if (columns[k].form == 'select') {
                    for (let kk in data) {
                        data[kk][columns[k].dataIndex] = this.$fan.page.getOptionName(columns[k].dataIndex, data[kk][columns[k].dataIndex])
                    }
                    }else if(columns[k].form == 'cascader'){
                        for (let kk in data) {
                            data[kk][columns[k].dataIndex] = this.$fan.page.getOptionName(columns[k].dataIndex, data[kk][columns[k].dataIndex])
                        }
                    }else if(columns[k].form == 'radio'){
                        for (let kk in data) {
                            data[kk][columns[k].dataIndex] = this.$fan.page.getOptionName(columns[k].dataIndex, data[kk][columns[k].dataIndex])
                        }
                    }
                }
                }
                this.$export.excel({
                columns: xlsColumns,
                data: data,
                })
            },
        }
    }
</script>
